import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6717e1d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "chart-theme-selector"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.colors, ([name, color], index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(['color', name]),
      key: index,
      style: _normalizeStyle({
        ['--bg-color']: color
      })
    }, null, 6);
  }), 128))]);
}